module.exports = __webpack_public_path__ + "img/product_1.f976cc5e.png";